import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import { CheckoutAddress } from 'src/redux/types/store';
import { PrimaryLinkButton } from './styles/index.styles';
import {
  AddressLine,
  CardRow,
  CopyStack,
  IconChip,
  Label,
} from './styles/BillingAddressCard.styles';

const BillingAddressCard = ({
  name,
  billingAddress,
  onChange,
  open = false,
}: {
  name: string;
  billingAddress: CheckoutAddress;
  onChange: () => void;
  /** Whether the inline edit shutter below this card is showing. */
  open?: boolean;
}) => (
  <CardRow>
    <IconChip>
      <LocationOnRoundedIcon sx={{ fontSize: 20 }} />
    </IconChip>
    <CopyStack>
      <Label>Billing to</Label>
      <AddressLine>
        {name}
        {billingAddress.state
          ? ` · ${billingAddress.state}, ${billingAddress.pincode}`
          : ''}
      </AddressLine>
    </CopyStack>
    <PrimaryLinkButton disableRipple onClick={onChange}>
      {open ? 'Close' : 'Change'}
    </PrimaryLinkButton>
  </CardRow>
);

export default BillingAddressCard;
